import React, { useEffect, useState, useRef } from 'react';
import { Footer } from '../../common/footer/Footer';
import Header from '../../common/header/Header';
import AuthenticatedContent from '../../common/AuthenticatedContent';

function PublicPages(props) {
	const [showHeader, setShowHeader] = useState(false);
	const [showFooter, setShowFooter] = useState(false);
	const inactivityTimer = useRef(null);

	// useEffect(() => {
	// 	const handleMouseMove = e => {
	// 		const { clientY } = e;
	// 		const windowHeight = window.innerHeight;

	// 		// логика показа header/footer
	// 		if (clientY < 100) {
	// 			setShowHeader(true);
	// 		} else {
	// 			setShowHeader(false);
	// 		}

	// 		if (clientY > windowHeight - 100) {
	// 			setShowFooter(true);
	// 		} else {
	// 			setShowFooter(false);
	// 		}

	// 		// сбрасываем таймер
	// 		if (inactivityTimer.current) {
	// 			clearTimeout(inactivityTimer.current);
	// 		}

	// 		inactivityTimer.current = setTimeout(() => {
	// 			setShowHeader(false);
	// 			setShowFooter(false);
	// 		}, 5000); // 5 секунд без движения
	// 	};

	// 	window.addEventListener('mousemove', handleMouseMove);
	// 	return () => {
	// 		window.removeEventListener('mousemove', handleMouseMove);
	// 		if (inactivityTimer.current) {
	// 			clearTimeout(inactivityTimer.current);
	// 		}
	// 	};
	// }, []);

	return (
		<>
			{/* {showHeader && <Header />} */}
			<div style={{ paddingBottom: showFooter ? '100px' : '0' }}>
				{props.children}
			</div>
			{/* {showFooter && <Footer />} */}
		</>
	);
}

export default PublicPages;
